// VFX: Collab Profile Badge
// Slug: ig_collab-tag_profile-badge_500ms
// Category: ui-elements
import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";
import React from "react";

const clamp = { extrapolateLeft: "clamp", extrapolateRight: "clamp" } as const;
type Props = { handleA?: string; handleB?: string; colorA?: string; colorB?: string };

function Avatar({ label, color, size = 140 }: { label: string; color: string; size?: number }) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        background: `linear-gradient(135deg, ${color}, ${color}77)`,
        border: "5px solid #fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontFamily: "system-ui, sans-serif",
        fontWeight: 800,
        fontSize: size * 0.4,
        boxShadow: "0 8px 24px rgba(0,0,0,0.4)",
      }}
    >
      {label}
    </div>
  );
}

export default function IgCollabTagProfileBadge500ms({
  handleA = "@guilherme",
  handleB = "@dimus",
  colorA = "#a855f7",
  colorB = "#06b6d4",
}: Props) {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const sp = spring({ frame, fps, config: { stiffness: 260, damping: 18 } });
  const merge = interpolate(sp, [0, 1], [120, 60], clamp);
  return (
    <AbsoluteFill
      style={{
        background: "#000",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: 30,
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ transform: `translateX(${interpolate(sp, [0, 1], [-200, 0], clamp)}px)`, opacity: sp }}>
          <Avatar label={handleA[1]?.toUpperCase() ?? "A"} color={colorA} />
        </div>
        <div
          style={{
            marginLeft: -merge,
            marginRight: -merge,
            width: 70,
            height: 70,
            borderRadius: "50%",
            background: "#fff",
            border: "4px solid #000",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "system-ui",
            fontWeight: 900,
            fontSize: 32,
            color: "#000",
            zIndex: 2,
            transform: `scale(${sp})`,
            opacity: sp,
          }}
        >
          ×
        </div>
        <div style={{ transform: `translateX(${interpolate(sp, [0, 1], [200, 0], clamp)}px)`, opacity: sp }}>
          <Avatar label={handleB[1]?.toUpperCase() ?? "B"} color={colorB} />
        </div>
      </div>
      <div
        style={{
          color: "#fff",
          fontFamily: "system-ui, sans-serif",
          fontWeight: 600,
          fontSize: 24,
          opacity: sp,
          letterSpacing: 1,
        }}
      >
        {handleA}  ×  {handleB}
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
